import React, {useEffect, useState} from 'react'
import { connect } from "react-redux";
import { Col, Row } from "reactstrap";

// components
import InHouseRequestList from "./_list";
import ModalNewWishlist from "../../../components/wishlist/tools/ModalNewWishlist";
import { showLoader } from "../../../components/loader/loader";
import WishlistHeader from "../../../components/wishlist/components/WishlistHeader";
import WishlistFitler from "../wishlist/_filters";

// actions
import { setApp, clearState } from '../../../redux/actions/generalActions/mainActions'
import { clearState as clearListState } from '../../../redux/actions/generalActions/listActions'

// css
import '../../../assets/css/Wishlist.css'

const InHouseRequest = props => {
    const { loading } = props?.mainState
    const selectedUdn =  JSON.parse(localStorage.getItem('selectedUdn') || '{}')

    const [ showNewModal, setShowNewModal ] = useState(false )

    const handleToggle = () => setShowNewModal(!showNewModal)

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);

        return () => {
            props.clearState()
            props.clearListState()
        }
    },[])

    return <>
        { loading && showLoader() }

        <WishlistHeader
            title={ selectedUdn?.label || '' }
            showButton={false}
            onClick={ handleToggle }
        />

        <WishlistFitler />

        <InHouseRequestList />

        <ModalNewWishlist
            isOpen={showNewModal}
            handleToggle={handleToggle}
        />
    </>
}

const mapStateToProps = state => ({
    mainState: state.mainProps,
})
const mapActionsToProps = ({
    setApp,
    clearState,
    clearListState,
})

export default connect(mapStateToProps, mapActionsToProps)(InHouseRequest)